module.exports = __webpack_public_path__ + "media/images/emp-unselect-97dcba56a2ffc266c5ab00d4349e1192.png";